<tt-page>
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-button-goto [ttText]="'new'" (ttClick)="goToFunc('textilemodelcategory5')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list class="col-xs-12 col-md-6 sp-0" [ttData]="itemsListCategories5"></tt-list>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-button class="col-xs-12 sp-0" tt-text="new" tt-click="vm.goToFunc('textilemodelcategory5')" tt-text-align="left" tt-icon="fa fa-solid fa-plus" tt-icon-pull-right="true"></tt-button>
    </tt-card>

    <im-list-directive class="col-xs-12 col-md-6 sp-0" list-items="vm.model.itemsListCategories5" badge="" ltype="" design-var="s12t0"></im-list-directive>
</tt-page>-->
